// import axios from "axios";

// const API_URL =
//     "https://backend.maamaas.com/subscription/employee-slot-plan";

// const getToken = () =>
//     localStorage.getItem("token") ||
//     localStorage.getItem("authToken");

// const headers = () => ({
//     Authorization: `Bearer ${getToken()}`,
//     "Content-Type": "application/json",
// });

// export const getEmployeeSlotPlans = async () => {
//     const response = await axios.get(API_URL, {
//         headers: headers(),
//     });
//     return response.data;
// };

// export const createEmployeeSlotPlan = async (data) => {
//     const response = await axios.post(API_URL, data, {
//         headers: headers(),
//     });
//     return response.data;
// };

// export const updateEmployeeSlotPlan = async (id, data) => {
//     const response = await axios.put(`${API_URL}/${id}`, data, {
//         headers: headers(),
//     });
//     return response.data;
// };

// export const deleteEmployeeSlotPlan = async (id) => {
//     const response = await axios.delete(`${API_URL}/${id}`, {
//         headers: headers(),
//     });
//     return response.data;
// };

import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/subscription/employee-slot-plan`;

const getToken = () =>
    localStorage.getItem("token") ||
    localStorage.getItem("authToken");

const headers = () => ({
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
});

// GET
export const getEmployeeSlotPlans = async () => {
    const response = await axios.get(API_URL, {
        headers: headers(),
    });
    return response.data;
};

// POST
export const createEmployeeSlotPlan = async (data) => {
    const response = await axios.post(API_URL, data, {
        headers: headers(),
    });
    return response.data;
};

// PUT
export const updateEmployeeSlotPlan = async (id, data) => {
    const response = await axios.put(`${API_URL}/${id}`, data, {
        headers: headers(),
    });
    return response.data;
};

// DELETE
export const deleteEmployeeSlotPlan = async (id) => {
    const response = await axios.delete(`${API_URL}/${id}`, {
        headers: headers(),
    });
    return response.data;
};